export default __webpack_public_path__ + "static/media/logo-edge.7cad8cc6.png";